module.exports = __webpack_public_path__ + "492e5f7aaa31a8095e55b11b9de673e1.jpg";